export default {"src":"/_next/static/media/downArrow.597ff35d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};